module.exports = "<ng-container>\n    <div class=\"logo-row {{layout}}\">\n        <div class=\"headline\">\n            <h3 class=\"title\">{{(item|meta).title}}</h3>\n            <div class=\"title-marker\" [attr.data-type]=\"item.obj_type\"></div>\n        </div>\n        <carousel-row class=\"logos\" [item]=\"item\" [items]=\"item.data\" [config]=\"carouselConfig\"></carousel-row>\n    </div>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/logo-row/logo-row.template.html
// module id = 817
// module chunks = 2